import type { Option } from '@usealloy/component-library';

export const BLANK_OPTION: Option = {
  label: 'select', value: '',
};

export const SUPPRESSION_UNIT_OPTIONS: Option[] = [
  { label: 'Days', value: 'days' },
  { label: 'Weeks', value: 'weeks' },
];

export const MAX_DESCRIPTION_LENGTH: number = 180;

export const MAX_NAME_LENGTH: number = 64;
